import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { TSS_BLUE, TSS_GREEN, TSS_RED } from 'tss-core-lib-common';

var styles = void 0;

var Progress = function Progress(_ref) {
  var progress = _ref.progress,
      error = _ref.error;
  return React.createElement(
    'div',
    { className: css(styles.container) },
    React.createElement('div', { className: css(styles.progress, progress >= 1 && styles.progressComplete, error && styles.progressError), style: { width: progress * 100 + '%' } })
  );
};

Progress.propTypes = {
  progress: PropTypes.number,
  error: PropTypes.bool
};

Progress.defaultProps = {
  progress: 0,
  error: null
};

styles = StyleSheet.create({
  container: {
    width: '100%',
    height: 4,
    display: 'flex',
    border: 0,
    borderRadius: 2,
    overflow: 'hidden'
  },

  progress: {
    backgroundColor: TSS_BLUE()
  },

  progressComplete: {
    backgroundColor: TSS_GREEN()
  },

  progressError: {
    backgroundColor: TSS_RED()
  }
});

export default Progress;